import './ActivityPanel.css';

export default function ActivityPanel({ activities }) {
  return (
    <aside className="activity-panel">
      <h3>Activité récente</h3>
      {activities.length === 0 ? (
        <p className="muted">Aucune activité pour le moment.</p>
      ) : (
        <ul>
          {activities.map((activity, index) => (
            <li key={index}>
              <span className={`dot ${activity.type}`} />
              <div>
                <p>{activity.message}</p>
                <span className="time">{activity.time}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
}
